/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ElectricalSettingsShortcutInformation } from './electrical-settings-menu-info';

export class ElectricalSettingsObjectInformation {
  result: ElectricalSettingsInformation;
}

export class ElectricalSettingsInformation {
  editDeleteAddFitting: boolean;
  rotationAngle: string;
  imageDescription: string;
  alternateDescription: string;
  tooltips: boolean;
  worksharingNotification: boolean;
  conduitRunSelection?: boolean;
  connectSize: string;
  isNominalSize?: boolean;
  menuInfo: ElectricalSettingsShortcutInformation[];
}
